import { BulkUpdateParams } from "../../../transactions/TransactionsBulkActions/lib";
import { extractRowActionValue } from "./seedActionRow";
import { ActionRowDefinition } from "./types";

export const CREATE_RULE_REQUIRES_CONDITION_TOOLTIP =
    "Add at least one condition before creating a rule.";
export const CREATE_RULE_REQUIRES_ACTION_VALUE_TOOLTIP =
    "Pick a target value before creating a rule.";
export const CREATE_RULE_REQUIRES_GROUP_TOOLTIP =
    "Select a rule group before creating a rule.";

export function isCreateRuleMissingGroup({
    rows,
    ruleGroupId,
}: {
    rows: ActionRowDefinition[];
    ruleGroupId: string;
}): boolean {
    return ruleGroupId === "" && rows.some((row) => row.createRule);
}

export function isCreateRuleMissingConditions(
    row: ActionRowDefinition,
): boolean {
    return row.createRule && row.conditions.length === 0;
}

export function isCreateRuleMissingActionValue(
    update: BulkUpdateParams["update"],
    row: ActionRowDefinition,
): boolean {
    return row.createRule && extractRowActionValue(update, row) === undefined;
}

export function isCreateRuleInvalid(
    update: BulkUpdateParams["update"],
    row: ActionRowDefinition,
): boolean {
    const hasNoConditionTypes =
        row.createRule &&
        row.conditions.every((condition) => !condition.conditionType);

    return (
        isCreateRuleMissingConditions(row) ||
        isCreateRuleMissingActionValue(update, row) ||
        hasNoConditionTypes
    );
}
